import ApiHelper from "../../helpers/ApiHelper";
import BaseService from "../BaseService";

class NegotiationService extends BaseService {

    static url = "negotiations";
    static apis = {
       
    }

    constructor(repo) {
        super(repo);
        this.repo = new ApiHelper("negotiations");
    }

}

export default NegotiationService;